(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-explorer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initExplorer = (root) => {
      if (!root || root.dataset.peInitialized === 'true') return;

      root.dataset.peInitialized = 'true';

      const primaryButtons = Array.from(root.querySelectorAll('.pe-primary-tab[data-primary-value]'));

      const modelButtons = Array.from(root.querySelectorAll('.pe-model-card[data-model-value]'));
      const refrigerationButtons = Array.from(
        root.querySelectorAll('.pe-refrigeration-card[data-refrigeration-value]')
      );

      let filterButtons = [];
      let productMapItems = Array.from(root.querySelectorAll('.pe-product-map-item'));

      const productMapContainer = root.querySelector('.pe-product-map');
      const productPaginationMeta = root.querySelector('[data-pe-product-total-pages]');

      const filterSection = root.querySelector('[data-pe-filter-section]');
      const filterOptionsContainer = root.querySelector('[data-pe-filter-options]');
      const productSelector = root.querySelector('[data-pe-product-selector]');
      const productSelectorOptions = root.querySelector('[data-pe-product-selector-options]');

      const filterDefinitions = Array.from(root.querySelectorAll('[data-pe-filter-definition]'));

      const heroLabel = root.querySelector('[data-pe-hero-label]');
      const heroTitle = root.querySelector('[data-pe-hero-title]');
      const heroDescription = root.querySelector('[data-pe-hero-description]');
      const heroImage = root.querySelector('[data-pe-hero-image]');
      const heroPlaceholder = root.querySelector('[data-pe-hero-placeholder]');
      const heroCta = root.querySelector('[data-pe-hero-cta]');
      const heroCtaLabel = root.querySelector('[data-pe-hero-cta-label]');

      const initialPrimary = (root.dataset.initialPrimary || '').trim().toLowerCase();

      let activePrimary = '';
      let activeFilter = '';
      let activeModel = 'all';
      let activeRefrigeration = 'all';
      let activeProductId = '';

      const normalize = (value) => {
        const normalized = String(value ?? '')
          .trim()
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');

        const aliases = {
          psaf: 'pfas',
          pfas: 'pfas',
          sediment: 'prefilter',
          'pre-filter': 'prefilter',
          prefilter: 'prefilter',
          vr: 'vandal-resistant',
          'vandal-resistant': 'vandal-resistant',
          'single-level': 'single-level',
          'bi-level': 'bi-level',
          '10k': '10k',
          uv: 'uv',
          'non-refrigerated': 'non-refrigerated',
          refrigerated: 'refrigerated',
        };

        return aliases[normalized] || normalized;
      };

      // Select Black Stainless by default (or the theme-editor override).
      // This is evaluated after normalize() is defined to avoid a JS TDZ error.
      const preferredPrimary = normalize(initialPrimary || 'black-stainless');
      const defaultPrimaryButton =
        primaryButtons.find((button) => normalize(button.dataset.primaryValue) === preferredPrimary) ||
        primaryButtons.find((button) => normalize(button.dataset.primaryValue) === 'black-stainless') ||
        primaryButtons[0] ||
        null;
      activePrimary = normalize(defaultPrimaryButton?.dataset.primaryValue || '');

      // Safely split stored values. A comma between digits is preserved so
      // "10,000 Gal" is not mistakenly split into "10" and "000 Gal".
      const splitExplorerValues = (value) => {
        return String(value ?? '')
          .split(/[|;+•·・\n]+|,(?!\d)/)
          .map((part) => String(part).trim())
          .filter(Boolean);
      };

      // Normalize common ways the 10,000-gallon filter is entered in Shopify.
      const canonicalFilterKey = (value) => {
        const key = normalize(value);
        const aliases = {
          '10-000': '10k',
          '10-000-gal': '10k',
          '10-000-gallon': '10k',
          '10-000-gallons': '10k',
          10000: '10k',
          '10000-gal': '10k',
          '10000-gallon': '10k',
          '10000-gallons': '10k',
          '10k-gal': '10k',
          '10k-gallon': '10k',
          '10k-gallons': '10k',
          'pfas-filter': 'pfas',
          'sediment-filter': 'prefilter',
          'pre-filter': 'prefilter',
        };
        return aliases[key] || key;
      };

      /*
       * Match normalized values using exact matches or whole hyphen-delimited
       * tokens. Refrigeration remains strictly separated: "non-refrigerated"
       * can never match "refrigerated".
       */
      const matchesExplorerValue = (actual, selected) => {
        const normalizedActual = normalize(actual);
        const normalizedSelected = normalize(selected);

        if (!normalizedSelected || normalizedSelected === 'all') return true;
        if (!normalizedActual) return false;

        const refrigerationValues = new Set(['non-refrigerated', 'refrigerated']);
        if (refrigerationValues.has(normalizedActual) || refrigerationValues.has(normalizedSelected)) {
          return normalizedActual === normalizedSelected;
        }

        if (normalizedActual === normalizedSelected) return true;

        const actualValues = splitExplorerValues(actual).map(normalize).filter(Boolean);
        if (actualValues.includes(normalizedSelected)) return true;

        // Also support values stored as a descriptive compound such as
        // "Vandal-Resistant Bottle Filler" without fuzzy substring matches.
        return `-${normalizedActual}-`.includes(`-${normalizedSelected}-`);
      };

      const normalizeCombination = (value) => {
        return String(value || '')
          .split('|')
          .map((part) => canonicalFilterKey(part))
          .filter(Boolean)
          .sort()
          .join('|');
      };

      // The Primary option Value / key entered in the Theme Editor is the
      // source of truth for Type matching. Nothing is hard-coded here, so
      // this section stays reusable for any future product family.
      const canonicalPrimaryValue = (value) => normalize(value);

      const humanizeFilterKey = (key) => {
        const normalizedKey = normalize(key);
        if (!normalizedKey) return '';
        return normalizedKey
          .split('-')
          .map((part) => part.toUpperCase())
          .join(' ');
      };

      const filterDefinitionsByKey = new Map(
        filterDefinitions
          .map((definition) => {
            const key = canonicalFilterKey(definition.dataset.filterValue);

            return [
              key,
              {
                value: key,
                label: definition.dataset.filterLabel || key,
                description: definition.dataset.filterDescription || '',
              },
            ];
          })
          .filter(([key]) => key)
      );

      const getPrimaryButton = () => {
        return (
          primaryButtons.find((button) => normalize(button.dataset.primaryValue) === activePrimary) || primaryButtons[0]
        );
      };

      const loadAutomaticProducts = async () => {
        if (!productMapContainer || !root.dataset.sectionId) return;

        const mergeProductMapItems = (doc) => {
          if (!doc) return;

          const existingIds = new Set(productMapItems.map((item) => item.dataset.mapProduct).filter(Boolean));

          doc.querySelectorAll('.pe-product-map-item').forEach((item) => {
            const productId = item.dataset.mapProduct;

            if (productId && existingIds.has(productId)) return;

            productMapContainer.appendChild(item.cloneNode(true));

            if (productId) existingIds.add(productId);
          });

          productMapItems = Array.from(root.querySelectorAll('.pe-product-map-item'));
        };

        const totalPages = Math.max(1, parseInt(productPaginationMeta?.dataset.peProductTotalPages || '1', 10));
        const currentPage = Math.max(1, parseInt(productPaginationMeta?.dataset.peProductCurrentPage || '1', 10));

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('section_id');

        const pages = [];
        for (let page = 1; page <= totalPages; page += 1) {
          if (page !== currentPage) pages.push(page);
        }

        if (!pages.length) {
          productMapItems = Array.from(root.querySelectorAll('.pe-product-map-item'));
          return;
        }

        const responses = await Promise.allSettled(
          pages.map(async (page) => {
            const urls = [];

            const sectionUrl = new URL(currentUrl.toString());
            sectionUrl.searchParams.set('section_id', root.dataset.sectionId);
            sectionUrl.searchParams.set('page', String(page));
            urls.push(sectionUrl);

            const collectionUrl = new URL(currentUrl.toString());
            collectionUrl.searchParams.set('page', String(page));
            urls.push(collectionUrl);

            for (const url of urls) {
              try {
                const response = await fetch(url.toString(), {
                  headers: { Accept: 'text/html' },
                });

                if (!response.ok) continue;

                const html = await response.text();
                const doc = new DOMParser().parseFromString(html, 'text/html');

                if (doc.querySelector('.pe-product-map-item')) {
                  return doc;
                }
              } catch (error) {
                // Try the next URL format for this page.
              }
            }

            return null;
          })
        );

        responses.forEach((result) => {
          if (result.status !== 'fulfilled' || !result.value) return;
          mergeProductMapItems(result.value);
        });

        productMapItems = Array.from(root.querySelectorAll('.pe-product-map-item'));
      };

      const getProductFilterValues = (item) => {
        const encodedValue = String(item?.dataset.mapFilters || '').trim();
        let storedValues = [];

        if (encodedValue) {
          try {
            const parsed = JSON.parse(encodedValue);
            storedValues = Array.isArray(parsed) ? parsed : [parsed];
          } catch (error) {
            storedValues = [encodedValue];
          }
        }

        const rawValues = storedValues
          .flatMap((value) => splitExplorerValues(value))
          .map((value) => canonicalFilterKey(value))
          .filter(Boolean);

        const expandedValues = [];

        rawValues.forEach((value) => {
          if (filterDefinitionsByKey.has(value)) {
            expandedValues.push(value);
            return;
          }

          // A product metafield may store a combination as one phrase, e.g.
          // "PFAS-UV" or "10K-GAL-Prefilter". Resolve only complete known
          // filter-key boundaries; do not match arbitrary substrings.
          const haystack = `-${value}-`;
          let matchedDefinition = false;

          filterDefinitionsByKey.forEach((_definition, key) => {
            if (haystack.includes(`-${key}-`)) {
              expandedValues.push(key);
              matchedDefinition = true;
            }
          });

          // Keep unknown values as real keys instead of silently discarding
          // them; the label can fall back to a readable version of the key.
          if (!matchedDefinition) expandedValues.push(value);
        });

        return Array.from(new Set(expandedValues.map(canonicalFilterKey))).sort();
      };

      const getProductFilterCombination = (item) => {
        const values = getProductFilterValues(item);

        if (!values.length) {
          return '';
        }

        return normalizeCombination(values.join('|'));
      };

      const hasCollectionPrimaryData = () => {
        return productMapItems.some((item) => normalize(item.dataset.mapPrimary) !== '');
      };

      const hasCollectionModelData = () => {
        return productMapItems.some((item) => normalize(item.dataset.mapModel) !== '');
      };

      const hasCollectionRefrigerationData = () => {
        return productMapItems.some((item) => normalize(item.dataset.mapRefrigeration) !== '');
      };

      const primaryValuesMatch = (mapPrimary, normalizedPrimary) => {
        const productType = canonicalPrimaryValue(mapPrimary);
        const selectedType = canonicalPrimaryValue(normalizedPrimary);

        if (!selectedType) return true;

        if (!productType) {
          return !hasCollectionPrimaryData();
        }

        return matchesExplorerValue(productType, selectedType);
      };

      const productBaseMatches = (item, primary, model, refrigeration) => {
        const mapPrimary = normalize(item.dataset.mapPrimary);
        const mapModel = normalize(item.dataset.mapModel);
        const mapRefrigeration = normalize(item.dataset.mapRefrigeration);

        const normalizedPrimary = normalize(primary);
        const normalizedModel = normalize(model);
        const normalizedRefrigeration = normalize(refrigeration);

        /*
         * CATEGORY
         */
        if (normalizedPrimary !== '') {
          if (!mapPrimary) {
            return false;
          }

          if (!primaryValuesMatch(mapPrimary, normalizedPrimary)) {
            return false;
          }
        }

        /*
         * CONFIGURATION
         */
        if (normalizedModel !== 'all') {
          if (hasCollectionModelData()) {
            if (!matchesExplorerValue(mapModel, normalizedModel)) {
              return false;
            }
          }
        }

        /*
         * REFRIGERATION
         */
        if (normalizedRefrigeration !== 'all') {
          if (hasCollectionRefrigerationData()) {
            if (!matchesExplorerValue(mapRefrigeration, normalizedRefrigeration)) {
              return false;
            }
          }
        }

        return true;
      };

      const productMatches = (item, primary, filter, model, refrigeration) => {
        if (!productBaseMatches(item, primary, model, refrigeration)) return null;

        const normalizedFilter = normalizeCombination(filter);
        const productCombination = getProductFilterCombination(item);

        if (normalizedFilter && productCombination !== normalizedFilter) {
          return null;
        }

        let score = 0;

        const mapPrimary = normalize(item.dataset.mapPrimary);
        const mapModel = normalize(item.dataset.mapModel);
        const mapRefrigeration = normalize(item.dataset.mapRefrigeration);

        const normalizedPrimary = normalize(primary);
        const canonicalMapPrimary = canonicalPrimaryValue(mapPrimary);
        const canonicalSelectedPrimary = canonicalPrimaryValue(normalizedPrimary);

        const normalizedModel = normalize(model);
        const normalizedRefrigeration = normalize(refrigeration);

        if (canonicalSelectedPrimary && canonicalMapPrimary === canonicalSelectedPrimary) {
          score += 4;
        }

        if (normalizedModel !== 'all' && mapModel === normalizedModel) {
          score += 4;
        }

        if (normalizedRefrigeration !== 'all' && mapRefrigeration === normalizedRefrigeration) {
          score += 4;
        }

        if (normalizedFilter && productCombination === normalizedFilter) {
          score += 8;
        }

        if (mapPrimary === '') score += 1;
        if (mapModel === '') score += 1;
        if (!productCombination) score += 1;

        return score;
      };

      const getMatchingProducts = () => {
        const matches = productMapItems
          .map((item) => ({
            item,
            score: productMatches(item, activePrimary, activeFilter, activeModel, activeRefrigeration),
          }))
          .filter(({ score }) => score !== null);

        if (matches.length) {
          matches.sort((a, b) => b.score - a.score);
          return matches.map(({ item }) => item);
        }

        // Some filter-replacement collections do not use the primary/category
        // metafield. Only those collections may use collection-level fallback.
        // When category data exists, zero results stay zero and can never borrow
        // products from another Type.
        if (!hasCollectionPrimaryData() && (activeFilter || activeModel !== 'all' || activeRefrigeration !== 'all')) {
          return productMapItems.filter((item) => {
            const mapModel = normalize(item.dataset.mapModel);
            const mapRefrigeration = normalize(item.dataset.mapRefrigeration);
            const normalizedModel = normalize(activeModel);
            const normalizedRefrigeration = normalize(activeRefrigeration);
            const combination = getProductFilterCombination(item);

            if (normalizedModel !== 'all' && hasCollectionModelData() && mapModel !== normalizedModel) {
              return false;
            }

            if (
              normalizedRefrigeration !== 'all' &&
              hasCollectionRefrigerationData() &&
              mapRefrigeration !== normalizedRefrigeration
            ) {
              return false;
            }

            if (activeFilter && combination !== normalizeCombination(activeFilter)) {
              return false;
            }

            return true;
          });
        }

        return [];
      };

      const getProductDisplayName = (item) => {
        const rawName = item?.dataset.mapName || 'Product';
        return rawName.split('|')[0].trim() || 'Product';
      };

      const buildProductSelector = () => {
        if (!productSelector || !productSelectorOptions) return;

        productSelectorOptions.innerHTML = '';

        // Only show this selector when multiple products share the same
        // current category + model + exact filter combination.
        if (!activeFilter) {
          activeProductId = '';
          productSelector.hidden = true;
          return;
        }

        const matchingProducts = getMatchingProducts();

        if (matchingProducts.length <= 1) {
          activeProductId = matchingProducts[0]?.dataset.mapProduct || '';
          productSelector.hidden = true;
          return;
        }

        const matchingIds = new Set(matchingProducts.map((item) => item.dataset.mapProduct));

        if (!matchingIds.has(activeProductId)) {
          activeProductId = matchingProducts[0]?.dataset.mapProduct || '';
        }

        matchingProducts.forEach((item, index) => {
          const productId = item.dataset.mapProduct || '';
          const button = document.createElement('button');

          button.type = 'button';
          button.className = 'pe-product-selector-option';
          button.dataset.productId = productId;
          button.setAttribute('aria-pressed', productId === activeProductId ? 'true' : 'false');

          if (productId === activeProductId) {
            button.classList.add('is-active');
          }

          const indexSpan = document.createElement('span');
          indexSpan.className = 'pe-product-selector-option-index';
          indexSpan.textContent = String(index + 1).padStart(2, '0');

          const nameSpan = document.createElement('span');
          nameSpan.className = 'pe-product-selector-option-name';
          nameSpan.textContent = getProductDisplayName(item);

          const arrowSpan = document.createElement('span');
          arrowSpan.className = 'pe-product-selector-option-arrow';
          arrowSpan.setAttribute('aria-hidden', 'true');
          arrowSpan.textContent = '→';

          button.appendChild(indexSpan);
          button.appendChild(nameSpan);
          button.appendChild(arrowSpan);

          button.addEventListener('click', () => {
            activeProductId = productId;
            buildProductSelector();
            updateHero();
          });

          productSelectorOptions.appendChild(button);
        });

        productSelector.hidden = false;
      };

      const hasBaseProductsForCurrentSelection = () => {
        return productMapItems.some((item) =>
          productBaseMatches(item, activePrimary, activeModel, activeRefrigeration)
        );
      };

      // Add ?pe-debug=1 to the URL to inspect mapped products and their fields.
      // This is silent during normal customer visits.
      const logExplorerDiagnostics = () => {
        if (new URLSearchParams(window.location.search).get('pe-debug') !== '1') return;

        const rows = productMapItems.map((item) => ({
          id: item.dataset.mapProduct || '',
          product: item.dataset.mapName || '',
          type: item.dataset.mapPrimary || '(blank)',
          configuration: item.dataset.mapModel || '(blank)',
          refrigeration: item.dataset.mapRefrigeration || '(blank)',
          rawFilter: item.dataset.mapFilters || '(blank)',
          normalizedFilter: getProductFilterCombination(item) || '(blank)',
          matchesType: activePrimary ? primaryValuesMatch(item.dataset.mapPrimary, activePrimary) : true,
          matchesConfiguration:
            activeModel === 'all' ||
            !hasCollectionModelData() ||
            matchesExplorerValue(item.dataset.mapModel, activeModel),
          matchesRefrigeration:
            activeRefrigeration === 'all' ||
            !hasCollectionRefrigerationData() ||
            matchesExplorerValue(item.dataset.mapRefrigeration, activeRefrigeration),
          passesAllBaseFilters: productBaseMatches(item, activePrimary, activeModel, activeRefrigeration),
        }));

        console.groupCollapsed(`[Product Explorer] ${rows.length} mapped products`);
        console.table(rows);
        console.groupEnd();
      };

      const findMappedProduct = () => {
        const matchingProducts = getMatchingProducts();

        if (activeProductId) {
          const selectedProduct = matchingProducts.find((item) => item.dataset.mapProduct === activeProductId);

          if (selectedProduct) return selectedProduct;
        }

        return matchingProducts[0] || null;
      };

      const getAvailableCombinations = () => {
        const collect = (requirePrimary) => {
          const combinations = new Map();

          productMapItems.forEach((item) => {
            if (requirePrimary) {
              if (!productBaseMatches(item, activePrimary, activeModel, activeRefrigeration)) {
                return;
              }
            } else {
              const mapModel = normalize(item.dataset.mapModel);
              const mapRefrigeration = normalize(item.dataset.mapRefrigeration);
              const normalizedModel = normalize(activeModel);
              const normalizedRefrigeration = normalize(activeRefrigeration);

              if (normalizedModel !== 'all' && hasCollectionModelData() && mapModel !== normalizedModel) {
                return;
              }

              if (
                normalizedRefrigeration !== 'all' &&
                hasCollectionRefrigerationData() &&
                mapRefrigeration !== normalizedRefrigeration
              ) {
                return;
              }
            }

            const combination = getProductFilterCombination(item);

            if (!combination) return;

            if (!combinations.has(combination)) {
              combinations.set(combination, combination.split('|'));
            }
          });

          return Array.from(combinations.entries());
        };

        const primaryCombinations = collect(true);

        // If category data exists, never fall back to combinations from other
        // Types. A selected Type with no products must produce zero filters.
        // Fallback remains available only for collections with no category data.
        return hasCollectionPrimaryData() ? primaryCombinations : collect(false);
      };

      const buildCombinationLabel = (parts) => {
        return parts.map((key) => filterDefinitionsByKey.get(key)?.label || humanizeFilterKey(key)).join(' + ');
      };

      const buildCombinationDescription = (parts) => {
        return parts
          .map((key) => filterDefinitionsByKey.get(key)?.description || '')
          .filter(Boolean)
          .join(' · ');
      };

      const syncFilterButtons = () => {
        filterButtons.forEach((button) => {
          const active = button.dataset.filterValue === activeFilter;

          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      const selectFilter = (button) => {
        if (!button) return;

        activeFilter = normalizeCombination(button.dataset.filterValue);
        activeProductId = '';

        syncFilterButtons();
        buildProductSelector();
        updateHero();
      };

      const buildFilterButtons = () => {
        if (!filterOptionsContainer) return;

        /*
         * Do not expose filters until the customer has explicitly selected:
         * Category + Configuration + Refrigeration.
         */
        const filtersReady = activePrimary !== '' && activeModel !== 'all' && activeRefrigeration !== 'all';

        if (!filtersReady) {
          activeFilter = '';
          activeProductId = '';
          filterOptionsContainer.innerHTML = '';
          filterButtons = [];

          if (productSelector) {
            productSelector.hidden = true;
          }

          if (filterSection) {
            filterSection.hidden = true;
          }

          return;
        }

        const combinations = getAvailableCombinations();

        // Keep the filter buttons in a predictable alphabetical order based
        // on the label customers actually see. Numeric sorting makes values
        // such as 4K and 10K sort naturally.
        combinations.sort((a, b) => {
          const labelA = buildCombinationLabel(a[1]);
          const labelB = buildCombinationLabel(b[1]);

          return labelA.localeCompare(labelB, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        });

        const availableKeys = new Set(combinations.map(([combination]) => normalizeCombination(combination)));
        const normalizedActiveFilter = normalizeCombination(activeFilter);

        if (!availableKeys.has(normalizedActiveFilter)) {
          activeFilter = '';
        } else {
          activeFilter = normalizedActiveFilter;
        }

        filterOptionsContainer.innerHTML = '';
        filterButtons = [];

        combinations.forEach(([combination, parts], index) => {
          const label = buildCombinationLabel(parts);
          const description = buildCombinationDescription(parts);

          const button = document.createElement('button');

          button.type = 'button';
          button.className = 'pe-filter-option';
          button.dataset.filterValue = combination;
          button.dataset.filterLabel = label;
          button.dataset.filterDescription = description;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-selected', 'false');

          const indexSpan = document.createElement('span');

          indexSpan.className = 'pe-filter-option-index';
          indexSpan.textContent = String(index + 1).padStart(2, '0');

          const mainSpan = document.createElement('span');

          mainSpan.className = 'pe-filter-option-main';

          const labelSpan = document.createElement('span');

          labelSpan.className = 'pe-filter-option-label';
          labelSpan.textContent = label;

          mainSpan.appendChild(labelSpan);

          const arrowSpan = document.createElement('span');

          arrowSpan.className = 'pe-filter-option-arrow';
          arrowSpan.setAttribute('aria-hidden', 'true');
          arrowSpan.textContent = '→';

          button.appendChild(indexSpan);
          button.appendChild(mainSpan);
          button.appendChild(arrowSpan);

          button.addEventListener('click', () => selectFilter(button));

          button.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
              return;
            }

            const buttons = filterButtons.filter((item) => !item.hidden);

            const currentIndex = buttons.indexOf(button);

            if (currentIndex < 0 || !buttons.length) {
              return;
            }

            const direction = event.key === 'ArrowRight' ? 1 : -1;

            const nextIndex = (currentIndex + direction + buttons.length) % buttons.length;

            buttons[nextIndex]?.focus();

            event.preventDefault();
          });

          filterOptionsContainer.appendChild(button);
          filterButtons.push(button);
        });

        if (filterSection) {
          filterSection.hidden = combinations.length === 0;
        }

        syncFilterButtons();
      };

      const setHeroFromPrimary = () => {
        const primaryButton = getPrimaryButton();

        const label = primaryButton?.dataset.primaryLabel || '';

        const title = primaryButton?.dataset.defaultTitle || label;

        const description = primaryButton?.dataset.defaultDescription || '';

        const image = primaryButton?.dataset.defaultImage || '';

        const imageAlt = primaryButton?.dataset.defaultImageAlt || label;

        if (heroLabel) {
          heroLabel.textContent = label;
        }

        if (heroTitle) {
          heroTitle.textContent = title;
        }

        if (heroDescription) {
          heroDescription.textContent = description;
        }

        if (heroImage && image) {
          heroImage.src = image;
          heroImage.alt = imageAlt;
          heroImage.classList.add('is-visible');

          heroPlaceholder?.classList.add('is-hidden');
        } else {
          heroImage?.removeAttribute('src');
          heroImage?.classList.remove('is-visible');
          heroPlaceholder?.classList.remove('is-hidden');
        }

        if (heroCta) heroCta.hidden = true;
      };

      const setHeroFromProduct = (item) => {
        if (!item) {
          setHeroFromPrimary();
          return;
        }

        const primaryButton = getPrimaryButton();

        const primaryLabel = primaryButton?.dataset.primaryLabel || '';

        const rawName = item.dataset.mapName || primaryLabel;

        const name = rawName.split('|')[0].trim();

        const image = item.dataset.mapImage || '';

        const imageAlt = item.dataset.mapImageAlt || name;

        const url = item.dataset.mapUrl || '#';

        const ctaText = item.dataset.mapCta || root.dataset.defaultCta || 'Shop Now';
        const productDescription = activeFilter
          ? buildCombinationDescription(normalizeCombination(activeFilter).split('|'))
          : '';

        if (heroLabel) {
          heroLabel.textContent = primaryLabel;
        }

        if (heroTitle) {
          heroTitle.textContent = name;
        }

        if (heroDescription) {
          heroDescription.textContent = productDescription;
        }

        if (heroImage && image) {
          heroImage.classList.remove('is-visible');

          window.setTimeout(() => {
            heroImage.src = image;
            heroImage.alt = imageAlt;
            heroImage.classList.add('is-visible');
          }, 80);

          heroPlaceholder?.classList.add('is-hidden');
        } else {
          heroImage?.removeAttribute('src');
          heroImage?.classList.remove('is-visible');
          heroPlaceholder?.classList.remove('is-hidden');
        }

        if (heroCta) {
          heroCta.href = url;
          heroCta.hidden = !url || url === '#';
        }

        if (heroCtaLabel) {
          heroCtaLabel.textContent = ctaText;
        }
      };

      const updateHero = () => {
        /*
         * The customer must explicitly choose all three prerequisites before
         * the filter selector can be used:
         * 1) Category / Primary
         * 2) Configuration / Model
         * 3) Refrigeration
         */
        const filtersReady = activePrimary !== '' && activeModel !== 'all' && activeRefrigeration !== 'all';

        if (!filtersReady) {
          activeFilter = '';
          activeProductId = '';

          if (productSelector) {
            productSelector.hidden = true;
          }

          if (filterSection) {
            filterSection.hidden = true;
          }

          setHeroFromPrimary();
          return;
        }

        if (filterSection) {
          filterSection.hidden = false;
        }

        /*
         * All prerequisites are selected, but no filter has been chosen yet.
         * Keep the category hero visible and wait for the customer to choose
         * a filter before showing a specific product.
         */
        if (!activeFilter) {
          activeProductId = '';

          if (productSelector) {
            productSelector.hidden = true;
          }

          setHeroFromPrimary();
          return;
        }

        buildProductSelector();
        setHeroFromProduct(findMappedProduct());
      };

      const syncPrimaryButtons = () => {
        primaryButtons.forEach((button) => {
          const active = normalize(button.dataset.primaryValue) === activePrimary;

          button.classList.toggle('is-active', active);

          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      const syncModelButtons = () => {
        modelButtons.forEach((button) => {
          const active = normalize(button.dataset.modelValue) === activeModel;

          button.classList.toggle('is-active', active);

          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const syncRefrigerationButtons = () => {
        refrigerationButtons.forEach((button) => {
          const active = normalize(button.dataset.refrigerationValue) === activeRefrigeration;

          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const refreshExplorerState = () => {
        buildFilterButtons();
        syncPrimaryButtons();
        syncModelButtons();
        syncRefrigerationButtons();
        updateHero();
        logExplorerDiagnostics();
      };

      const selectPrimary = (button) => {
        if (!button) return;

        activePrimary = normalize(button.dataset.primaryValue);

        activeFilter = '';
        activeModel = 'all';
        activeRefrigeration = 'all';
        activeProductId = '';

        refreshExplorerState();
      };

      const selectModel = (button) => {
        if (!button) return;

        activeModel = normalize(button.dataset.modelValue) || 'all';

        activeFilter = '';
        activeProductId = '';

        refreshExplorerState();
      };

      const selectRefrigeration = (button) => {
        if (!button) return;

        activeRefrigeration = normalize(button.dataset.refrigerationValue) || 'all';

        activeFilter = '';
        activeProductId = '';

        refreshExplorerState();
      };

      primaryButtons.forEach((button) => {
        button.addEventListener('click', () => selectPrimary(button));

        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
            return;
          }

          const currentIndex = primaryButtons.indexOf(button);

          if (currentIndex < 0 || !primaryButtons.length) {
            return;
          }

          const direction = event.key === 'ArrowRight' ? 1 : -1;

          const nextIndex = (currentIndex + direction + primaryButtons.length) % primaryButtons.length;

          primaryButtons[nextIndex]?.focus();

          event.preventDefault();
        });
      });

      modelButtons.forEach((button) => {
        button.addEventListener('click', () => selectModel(button));
      });

      refrigerationButtons.forEach((button) => {
        button.addEventListener('click', () => selectRefrigeration(button));
      });

      // Type defaults to the configured initial Type (Black Stainless by
      // default). Configuration and refrigeration still require user input.
      syncPrimaryButtons();
      syncModelButtons();
      syncRefrigerationButtons();
      buildFilterButtons();

      loadAutomaticProducts().finally(() => {
        productMapItems = Array.from(root.querySelectorAll('.pe-product-map-item'));

        buildFilterButtons();
        updateHero();
        logExplorerDiagnostics();
      });
    };

    const boot = () => {
      document.querySelectorAll('[data-product-explorer]').forEach(initExplorer);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.matches?.('[data-product-explorer]')) {
        initExplorer(event.target);
      } else {
        event.target?.querySelectorAll?.('[data-product-explorer]').forEach(initExplorer);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
